import { Subtext, TableItem } from '../components/Table';
import { EMPTY_TEXT } from './formatHelpers';

/* eslint-disable import/prefer-default-export */
export const fieldBodyGenerator = (
  label: string | null | undefined,
  styles: Record<string, any> = {},
  subtexts: Subtext[] = []
): TableItem => ({
  label: label ?? EMPTY_TEXT,
  styles,
  subtexts
});

export const sumFieldAcres = (
  fields: {
    areaValue: number;
  }[]
) => fields.reduce((prev, curr) => prev + curr.areaValue, 0);
